/* eslint-disable no-param-reassign */
import { PayloadAction } from '@reduxjs/toolkit';
import { PermissionsState } from '../permissions.slice';
import { PermissionRoles } from '../../services/projects.service';
import Membership from '../../models/membership';
import Group from '../../models/groups';

export default function setDefaults(
  state: PermissionsState,
  actions: PayloadAction<{
    members: Membership[];
    groups: Group[];
    user: PermissionRoles['user']
  }>,
) {
  const { members, groups, user } = actions.payload;
  const { roles, owners } = user;

  state.selectedMembers = members;
  state.selectedGroups = groups;
  state.roles = roles;
  state.ownerRoles = owners;
}
